import { DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import SortIcon from "../../../global/components/SortIcon";
import { Tooltip } from "antd";
import { formatUTCTime } from "../../../global/utils/unixToLocalTime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

export const DeviceProductionColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params,
) => {
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {};
  const isSystemUser = [1, 2, 3].includes(loggedInUser?.role_value);

  return [
    {
      title: "No",
      dataIndex: "ProductionNo",
      key: "ProductionNo",
      hidden: !isSystemUser,
      sorter: (a, b) => a?.ProductionNo - b?.ProductionNo,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="ProductionNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams({
            ...modParams,
            sort_by: "ProductionNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          }),
      }),
    },
    {
      title: "Name",
      dataIndex: "ProductionName",
      key: "ProductionName",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="ProductionName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams({
            ...modParams,
            sort_by: "ProductionName",
            order: modParams.order === "desc" ? "asc" : "desc",
          }),
      }),
    },
    {
      title: "Description",
      dataIndex: "ProductionDesc",
      key: "ProductionDesc",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="ProductionDesc"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams({
            ...modParams,
            sort_by: "ProductionDesc",
            order: modParams.order === "desc" ? "asc" : "desc",
          }),
      }),
    },
    {
      title: "Production Time",
      dataIndex: "ProductionTime",
      key: "ProductionTime",
      render: (text) => <div>{text ? formatUTCTime(text) : ""}</div>,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="ProductionTime"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams({
            ...modParams,
            sort_by: "ProductionTime",
            order: modParams.order === "desc" ? "asc" : "desc",
          }),
      }),
    },
    {
      title: "Hardware",
      dataIndex: "HardwareNo",
      key: "HardwareNo",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="HardwareNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams({
            ...modParams,
            sort_by: "HardwareNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          }),
      }),
    },
    {
      title: "License",
      dataIndex: "LicenseNo",
      key: "LicenseNo",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="LicenseNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams({
            ...modParams,
            sort_by: "LicenseNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          }),
      }),
    },
    {
      title: "Device Count",
      dataIndex: "DeviceCount",
      key: "DeviceCount",
    },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) =>
        hoveredRow === rowIndex ? (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Edit">
                <div className="hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] mr-1 ">
                  <Link
                    to={`/device-production/edit/${record?.ProductionNo}`}
                    onClick={(e) => e.stopPropagation()}
                    className=" hover:text-[#636262ee]"
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="!text-[#50565e]"
                    />
                  </Link>
                </div>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([record?.ProductionNo]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] "
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        ) : null,
    },
  ];
};
